import { v4 as uuidv4 } from 'uuid';

// Provides a unique user ID for the current session.
// Primarily used for tracking user activity, not for authentication.
// If the user is logged in, the ID the user's axid.
// If the user is not logged in and the ID is not in sessionStorage, a new ID is generated and stored in sessionStorage.
function getUniqueSessionUserId() {
  const uid = sessionStorage.getItem('uid');

  if (!uid) {
    sessionStorage.setItem('uid', `anonymous+${uuidv4()}`);
  }

  return sessionStorage.getItem('uid') ?? '';
}

export { getUniqueSessionUserId };
